import { createSelector } from 'reselect';
import { selectIsAuctionSelected } from '../auction';

export const selectActiveAdditionalIds = createSelector(
  [state => selectIsAuctionSelected(state)],
  (isAuctionSelected): Array<string> => {
    const services = [];

    if (isAuctionSelected) {
      services.push('auction');
    }

    return services;
  },
);
